import { ACTION_VIEW_QUESTION_ANSWERS } from 'utils/analytics/eventTypeConstantsAmplitude';
import { AnsweredQuestionsDialog } from './AnsweredQuestionsDialog';
import { Button, Typography } from 'omakase';
import { IconCheckmarkCircle, IconNote } from '@tock/icons';
import { core } from '@tock/coretypes';
import {
  headingWithAdornment,
  submittedContainer,
  successIcon,
} from 'components/business/receipts/previsitQuestionsCssDefs';
import { useAmplitudeSendEvent } from 'utils/analytics/AnalyticsContext';
import { useState } from 'react';

type AnsweredQuestionsBannerProps = {
  purchase: core.PastPurchase;
};

export const AnsweredQuestionsBanner = ({ purchase }: AnsweredQuestionsBannerProps) => {
  const amplitudeSendEvent = useAmplitudeSendEvent();
  const [viewingAnswers, setViewingAnswers] = useState(false);

  const handleClickViewAnswers = () => {
    setViewingAnswers(true);
    amplitudeSendEvent(ACTION_VIEW_QUESTION_ANSWERS);
  };

  const handleCloseViewAnswers = () => {
    setViewingAnswers(false);
  };

  return (
    <div css={submittedContainer}>
      <Typography variant="heading04" css={headingWithAdornment}>
        <IconNote />
        Pre-visit questions
        <IconCheckmarkCircle css={successIcon} />
      </Typography>

      <Button
        variant="basic"
        size="medium"
        fullWidth
        onClick={handleClickViewAnswers}
        data-testid="view-answers-button"
      >
        View
      </Button>
      <AnsweredQuestionsDialog
        open={viewingAnswers}
        onClose={handleCloseViewAnswers}
        purchase={purchase}
      />
    </div>
  );
};
